<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 15,
            title: "TERMINOS DE FACTURACION",
            columns: ["clave", "descripcion", "abreviatura", "nivel", "actions"],
            options: {
                filterable: ["clave", "descripcion", "abreviatura", "nivel"],
                sortable: ["clave", "descripcion", "abreviatura", "nivel"],

                headings: {
                    clave: "Clave",
                    descripcion: "Descripción",
                    abreviatura: "Abreviatura",
                    nivel: "Nivel",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion",
                Abreviatura: "abreviatura",
                Nivel: "nivel"
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion",
                abreviatura: "abreviatura",
                nivel: "nivel"
            },
            camposLayout: [{
                clave: "[Clave del Término de Facturación]",
                descripcion: "[Descripción del Término de Facturación]",
                abreviatura: "[Abreviatura del Término de Facturación]",
                nivel: "[Nivel del Término de Facturación]"
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: "",
                abreviatura: "",
                nivel: ""
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave",
                    value: "",
                    maxlen: 10
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 200
                },
                abreviatura: {
                    requiered: true,
                    label: "Abreviatura",
                    value: "",
                    maxlen: 100
                },
                nivel: {
                    requiered: true,
                    label: "Nivel",
                    value: "",
                    maxlen: 100
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>